<script setup lang="ts">
import { RefreshCw } from '@lucide/vue'
import { useI18n } from 'vue-i18n'

import { Button } from '@/components/ui/button/index'

import { usePwaUpdate } from '../composables/usePwaUpdate'

const { updateAvailable, refresh } = usePwaUpdate()
const { t } = useI18n()
</script>

<template>
    <Transition name="banner">
        <div
            v-if="updateAvailable"
            class="pwa-update-banner"
        >
            <span class="pwa-update-banner__message">
                {{ t('portal.pwa.update_available') }}
            </span>
            <Button
                size="sm"
                variant="secondary"
                class="pwa-update-banner__btn"
                @click="refresh"
            >
                <RefreshCw class="size-4" />
                {{ t('portal.pwa.refresh') }}
            </Button>
        </div>
    </Transition>
</template>

<style scoped>
.pwa-update-banner {
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 0.5rem 1rem;
    font-size: 0.875rem;
    background: oklch(0.85 0.15 70 / 0.3);
    color: oklch(0.35 0.12 70);
    border-bottom: 1px solid oklch(0.7 0.15 70 / 0.4);
}

.dark .pwa-update-banner {
    background: oklch(0.35 0.12 70 / 0.25);
    color: oklch(0.92 0.1 85);
    border-color: oklch(0.6 0.15 70 / 0.3);
}

.pwa-update-banner__message {
    flex: 1;
    font-weight: 500;
}

.pwa-update-banner__btn {
    flex-shrink: 0;
}

.banner-enter-active,
.banner-leave-active {
    transition: all 0.2s ease;
}

.banner-enter-from,
.banner-leave-to {
    opacity: 0;
    transform: translateY(-4px);
}
</style>
